import React, { Component } from 'react'
import { connect } from'react-redux'
import Cleave from 'cleave.js/react'

class CreditCvvField extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		const {input, label, size, meta: { valid, touched, error }} = this.props
		const { configData } = this.props
		const hotelLabels = configData.hotel.labels[0]

		return (
			<div className="u-form-row">
				<label id={ input.name + 'Label' } className="u-form-label" htmlFor={ input.name }>*{ label }</label>

				{ process.env.REACT_APP_COMPONENT_PAYMENT_FORMS_LAYOUT === 'default' &&
					hotelLabels.securityCodeMessage &&
					<p className="u-form-sublabel--top u-font-small">{ hotelLabels.securityCodeMessage }</p>
				}

				<div className={
					touched && error ?
						'u-form-col u-form-col--error u-form-col--' + size
					: touched && valid ?
						'u-form-col u-form-col--valid u-form-col--' + size
					:
						'u-form-col u-form-col--' + size
				}>
					<Cleave
						{ ...input }
						aria-labelledby={ input.name + 'Label' }
						options={{ blocks: [4], numericOnly: true }}
					/>
					{ touched && ((error && <p className="u-font-error">{ error }</p>)) }
				</div>

				{ process.env.REACT_APP_COMPONENT_PAYMENT_FORMS_LAYOUT === 'condensed' &&
					hotelLabels.securityCodeMessage &&
					<p className="u-form-sublabel--top u-font-small">{ hotelLabels.securityCodeMessage }</p>
				}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration
	}
}

export default connect(mapStateToProps, null)(CreditCvvField)


// WEBPACK FOOTER //
// ./src/components/forms/creditCardForm/elements/CreditExpiryCvv.js